import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.tilkiotomasyon.com',
});

export default apiClient;
